import React from 'react';
import { logger } from '../utils/logger';
import ErrorFallbackUI from './ErrorFallbackUI';

/**
 * Error Boundary component to catch React component crashes
 * and display a user-friendly fallback UI
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  /**
   * Update state when an error is caught
   */
  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error
    };
  }

  /**
   * Log error details when component catches an error
   */
  componentDidCatch(error, errorInfo) {
    // Log the error with component stack trace
    logger.error('React Component Error', error, {
      componentStack: errorInfo.componentStack,
      errorBoundary: true
    });

    // Store error info in state for debugging
    this.setState({
      errorInfo
    });
  }

  /**
   * Reset error boundary state
   */
  handleReset = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null
    });
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorFallbackUI
          error={this.state.error}
          onReset={this.handleReset}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
